<template>
  <div class="page border-box" v-wechat-title="$route.meta.title='AR虚拟体验'">
    <!--<div class="top-fixed box border-box">-->
      <!--<div class="flex border-box">-->
        <!--<input type="text" placeholder="输入名称进行搜索">-->
      <!--</div>-->
      <div class="menu-icon" :class="menuState==1?'one':'two'" @click="menuStateFun"></div>
    <!--</div>-->
    <div class="tab-box box">
      <div class="flex" :class="state==0?'curr':''" @click="tabFun(0)"><span><font>全部</font></span></div>
      <div class="flex" :class="state==1?'curr':''" @click="tabFun(1)"><span><font>热门推荐</font></span></div>
      <div class="flex" :class="state==2?'curr':''" @click="tabFun(2)"><span><font>最新上线</font></span></div>
    </div>
    <div class="list border-box clearfix" :class="menuState==1?'one':'two'" v-if="total>0">
      <div class="item" v-for="(item,index) in root" :key="index" @click="toDesc(item)">
        <img class="img" :src="item.qrimg" alt="">
        <div class="bot box border-box">
          <div class="l flex name hide">{{item.name}}</div>
          <div class="r">{{item.times|initNumber}}人体验</div>
        </div>
      </div>
      <!--<div class="item">-->
        <!--<img class="img" src="../../assets/ar/img2.png" alt="">-->
        <!--<div class="bot box border-box">-->
          <!--<div class="l flex name hide"><font>四川博物院-</font>三世佛</div>-->
          <!--<div class="r">29.62万人体验</div>-->
        <!--</div>-->
      <!--</div>-->
    </div>
    <p class="load-tip">{{loadText}}</p>

    <div class="no-data" v-if="total==0">
      <img src="../../assets/ar/no-data.png" alt="">
      <p>暂无内容！</p>
    </div>
  </div>

</template>

<script>
  import { mapState, mapMutations } from 'vuex'
  import {arList,arClick} from "@/service/getData";
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'
  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return{
        menuState:2,//1每排单个 2两个
        state:0,//顶部切换curr
        tipAlertShow:1,//提示弹窗显示与隐藏
        page: 1,
        rows: 10,
        loadText: "数据加载中",
        root:'',//评论列表
        total:'',//评论总条数
        TimeStamp: new Date().getTime(),  //获取当前时间
      }
    },
    computed: {

    },
    created() {
      this.$loading.show('数据加载中');
      this.userInfo = getStore("userInfo");
      this.initData(this.page);
      window.addEventListener("scroll",this.handleFun);
    },
    beforeDestroy(){
      window.removeEventListener("scroll",this.handleFun)
    },
    methods: {
      //获取列表
      async initData(page){
        let res = await arList({
          TimeStamp: this.TimeStamp,
          page: page,
          rows: this.rows,
          state:this.state
        });
        if (res.errcode === "00000"){
          this.$loading.hide();
          console.log(res)
          this.total = res.data.total
          let root = res.data.list
          if (page >= Math.ceil(this.total / this.rows)) {
            this.loadText = '已经到底了'
          } else {
            this.loadText = '加载更多'
          }
          if (root.length > 0) {
            this.root = [...this.root, ...root];
          } else {
            if (page == 1) {
              this.root = [];
              this.loadText = '暂无数据'
            } else {
              this.loadText = '已经到底了'
            }
          }
        }
      },

      //上传点击体验数据
      async arClickFun(code){
        let res = await arClick({
          openid: this.userInfo.openid,
          code: code
        });
      },

      handleFun: function (){
        let self = this;
        self.$nextTick(function() {
          loadMore(self,function(page){
            self.initData(page);
          });
        })
      },
      //顶部切换
      tabFun(id){
        this.state = id;
        this.$loading.show('数据加载中');
        this.page = 1;
        this.root = [];
        this.initData(this.page);
      },
      menuStateFun(){
        if(this.menuState==1){
          this.menuState = 2;
        }else{
          this.menuState = 1;
        }
      },
      toDesc(item){

        if(item.url){
          this.arClickFun(item.code);
          setTimeout(function(){
            window.location.href = item.url
          },200);
        }
      }
    },
    components: {

    },
    //格式化数据
    filters: {
      initNumber: function (num) {
        if(num>10000){
          num = (num/10000).toFixed(2)+'万'
        }else if(num>1000){
          num = (num/1000).toFixed(2)+'千'
        }
        return num;
      }
    }

  }

</script>

<style scoped>
  @import "../../style/alert.css";
  .page{width: 100vw;min-height: 100vh;background-color:#ededed;}
  .top-fixed{position: fixed;top:0;left: 0;z-index: 1;width: 100%;height: .96rem;padding: .16rem .3rem;background-color: #fff;border-bottom: 1px solid #ededed;}
  .top-fixed .flex{height:.64rem;padding: .12rem .64rem;border-radius:.32rem;background: #f2f2f2 url(../../assets/ar/icon-search.png) no-repeat center;background-size: .24rem .26rem;background-position-x: .24rem;}
  .top-fixed .flex input{font-size: .28rem;line-height: .4rem;color: #333;background: none;}
  .menu-icon{
    position: fixed;bottom: 20%;right: 2%;z-index: 9;
    width: .96rem;height: .96rem;background-color: #fff;box-shadow: 0 0 .26rem rgba(0,0,0,.2);border-radius: 50%;
    /*height: 100%;*/
    /*margin-left: .3rem;*/
  }
  .menu-icon.one{background: #fff url(../../assets/ar/icon-one.png) no-repeat center;background-size: 0.56rem auto;}
  .menu-icon.two{background: #fff url(../../assets/ar/icon-two.png) no-repeat center;background-size: 0.56rem auto;}

  /*顶部切换分类*/
  .tab-box{position:fixed;z-index: 1;top:0;
    /*top:.96rem;*/
    left:0;width:100%;height:.96rem;text-align: center;background: #fff;}
  .tab-box .flex span{position: relative;display:inline-block;height:.96rem;font: bold .3rem/.96rem "Microsoft YaHei";color:#333;}
  .tab-box .flex.curr span{font-size: .34rem;}
  .tab-box .flex.curr span font{position: relative;z-index: 1;}
  .tab-box .flex.curr span:after{content: '';position: absolute;bottom: .32rem;left: 0;right: 0;height: .08rem;background-color: #ffc303;}
  .list{
    /*padding: 2.24rem .3rem 0;*/
    padding: 1.28rem .3rem 0;}
  .list .item{float:left;margin-top: .3rem;border-radius: .14rem;background: #fff;}
  .list .item .img{display: block;border-radius: .14rem;}
  .list .item .bot{padding:0 .24rem;color: #222;}
  .list .item .r{color: #999;text-align: right;}

  .list.one .item{width: 100%;}
  .list.one .item:first-child,.list.two .item:nth-of-type(1),.list.two .item:nth-of-type(2){margin-top: 0;}
  .list.one .item{height: 6.1rem;}
  .list.one .item .img{height: 5.18rem;}
  .list.one .item .bot{font: bold .32rem/.92rem "Microsoft YaHei";color: #222;}
  .list.one .item .r{width: 30%;font: bold .26rem/.92rem "Microsoft YaHei";}
  .list.two .item{width: 48.7%;margin-right: 2.6%;}
  .list.two .item:nth-of-type(2n){margin-right: 0;}
  .list.two .item{height: 3.28rem;}
  .list.two .item .img{height: 2.54rem;}
  .list.two .item .bot{font: bold .28rem/.74rem "Microsoft YaHei";color: #333;}
  .list.two .item .name font{display: none;}
  .list.two .item .r{width: 56%;font: bold .2rem/.74rem "Microsoft YaHei";}
  .no-data{padding-top: 3.8rem;}
  .no-data img{display: block;width: 51.33%;height: auto;margin: 0 auto;}
  .no-data p{text-align: center;margin-top: .4rem;font-size: .34rem;color: #cdcdcd;}
</style>



// WEBPACK FOOTER //
// src/page/ar/ar-list-ty.vue